import React from "react";
import { Link } from "react-router-dom";

import logo from "../../assets/logo/logo_main.png";
import logoLight from "../../assets/logo/logo_white.svg";

import { MAIN_ROUTES } from "../../utils/routes";

const LOGO_SOURCE = {
  default: logo,
  light: logoLight,
};

const Logo = ({ className, variant = "default" }) => {
  return (
    <Link
      aria-label="NeurDB home"
      className={`shrink-0 ${className}`}
      to={MAIN_ROUTES.get("HOME").PATH}
    >
      <img
        alt="NeurDB"
        className="h-6 w-auto object-contain"
        src={LOGO_SOURCE[variant]}
      />
    </Link>
  );
};

export default Logo;
